module.exports = __webpack_public_path__ + "img/cabañatinajas.9ae9b5fe.jpg";